import { SubjectType } from "../../../types/Subject";
import { SubjectPlanType } from "../../../types/SubjectPlan";
import { put } from "../../../utils/axios-config";
import { SUBJECTS, SUBJECTS_PLAN } from "../../../utils/constants";

export const updateSubject = async (data: SubjectType) => await put<SubjectType, boolean>(`${SUBJECTS}`, data);
export const updateSubjectPlan = async (data: SubjectPlanType) => {
    return await put<SubjectPlanType, string>(SUBJECTS_PLAN, data);
  };